import Api from '@/services/Api'

export default {
  filter (name) {
    console.log("In rank filter service name=" + name) ;
    var results = Api().get('rank/filter?name=' + name) ;
    console.log("In rank filter service back from server results=" + results) ;
    return results ;
  },
  index (name, service, start, pageSize) {
    var results = Api().get("rank?name=" + name + ((service) ? ("&service=" + service) : "") +
      "&start=" + start + "&limit=" + pageSize) ;
    console.log("In rank service back from server results=" + results) ;
    return results ;
  },
  id (rankType, rankId) {
    console.log("in rank id = " + rankId) ;
    var results = Api().get("rank/" + rankType + "/" + rankId) ;
    console.log("Back from API GET rank ID") ;
    return results ; 
  },
  create (newRank) {
    console.log("in create rank") ;
    var results = Api().post('rankCreate', newRank) ;
    console.log("after create, results=" + results) ;
    return results ;
  },
  edit (edittedRank) {
    var results = Api().post('rankUpdate', edittedRank) ;
    console.log("after edit, results=" + results) ;
    return results ;
  },
  mergeTo (edittedRank) {
    console.log("in mergeTo serviced edittedrank=" + JSON.stringify(edittedRank)) ;
    
    var results = Api().post('rankMergeTo', edittedRank) ;
    console.log("after mergeTo, results=" + results) ;
    return results ;
  }  
}



// WEBPACK FOOTER //
// ./src/services/RankService.js